import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { ADMIN_MANY_ORDERS_API_PATHS } from '../constants/orders-api-paths.constant';
import { Order } from '../types/order.type';

interface LastUserOrdersResponse {
  status: string;
  data: { orders: Order[] };
}

type UseGetLastUserOrdersResult = {
  isLoading: boolean;
  lastOrder: Order | null;
};

export function useGetLastUserOrders(userId: string | undefined): UseGetLastUserOrdersResult {
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState<UseGetLastUserOrdersResult>({ isLoading: false, lastOrder: null });

  useEffect(() => {
    if (!userId) return;

    setState({ isLoading: true, lastOrder: null });

    const url = ADMIN_MANY_ORDERS_API_PATHS.GET_LAST_USER_ORDERS.replace(':userId', userId);

    HttpClient.get<LastUserOrdersResponse>(url)
      .then((response) => {
        setState({ isLoading: false, lastOrder: response.data.orders[0] ?? null });
      })
      .catch((error) => {
        enqueueSnackbar(
          extractApiErrorMessage(error, 'Une erreur est survenue lors de la récupération des dernières commandes'),
          { variant: 'error' }
        );
        setState({ isLoading: false, lastOrder: null });
      });
  }, [userId]);

  return state;
}
